import { HttpStatusCode } from "axios";
import {
  refreshToken,
  type refreshTokenResponseSuccess,
} from "@/api/__generated__/orval/auth";
import { accessTokenAtom, refreshTokenAtom, store } from "@/store";

// Shared promise to handle multiple simultaneous refresh token requests across all API clients
// Due to Venus and new MS Api usage. Once Venus is gone, we can refactor this to be in MS client.
let refreshTokenPromise: Promise<refreshTokenResponseSuccess> | null = null;

export const performRefreshToken = async (): Promise<void> => {
  // If a refresh is already in progress, wait for it
  if (refreshTokenPromise) {
    await refreshTokenPromise;
    return;
  }

  // Start the refresh and store the promise
  refreshTokenPromise = refreshToken({
    refreshToken: store.get(refreshTokenAtom),
  })
    .then((response) => {
      if (response.status === HttpStatusCode.Ok) {
        store.set(accessTokenAtom, response.data.data?.accessToken || "");
        store.set(refreshTokenAtom, response.data.data?.refreshToken || "");
        return response;
      }
      store.set(accessTokenAtom, "");
      store.set(refreshTokenAtom, "");
      throw new Error("refresh_token_failed");
    })
    .catch((_err) => {
      store.set(accessTokenAtom, "");
      store.set(refreshTokenAtom, "");
      throw new Error("refresh_token_failed");
    })
    .finally(() => {
      refreshTokenPromise = null;
    });

  await refreshTokenPromise;
};
